import { CHANGE_USER_STATUS_REQUEST, CHANGE_USER_STATUS_SUCCESS, CHANGE_USER_STATUS_FAILURE } from '../constants/change_user_status.constants';

export const changeUserStatusRequest = (params, callback) => ({
    type: CHANGE_USER_STATUS_REQUEST,
    params,
    callback,
});

export const changeUserStatusRequestSuccess = user => ({
    type: CHANGE_USER_STATUS_SUCCESS,
    user,
});

export const changeUserStatusRequestFailure = error => ({
    type: CHANGE_USER_STATUS_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/actions/change_user_status.actions.js